import { Component, effect, signal, WritableSignal } from '@angular/core';
import { CaseRecord, CaseSheetParams, CaseSheetResponse } from '../models/case-sheet.model';
import { IBreadcrumb } from '@lib/models/breadcrumb.model';
import { BreadcrumbComponent } from '@app/lib/components/breadcrumb/breadcrumb.component';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TAny, TKeyValue } from '@app/lib/models/common.type';
import { ECaseCategory } from '../models/constant';
import { MatIconModule } from '@angular/material/icon';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
import { MatDialog } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ILoginData } from '@app/lib/models/login.model';
import { AssignedTaskService } from '../services/assigned-task.service';
import { ETaskScreenName, IAssignedTask, IAssignedTaskEvent } from '../models/assigned-task.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, filter, switchMap } from 'rxjs';
import { IResponse } from '@app/lib/models/response.model';
import { ICaseItem, ICaseSearchRequestBody, ISearchRequestParams } from '../models/case-assignment.model';
import { DocumentReceptionService } from '../services/document-reception.service';
import { HearingNotice } from '../models/hearing-notice.model';
import { HearingNoticeService } from '../services/hearing-notice.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DialogService } from '@app/lib/services/dialog.service';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { CaseNumberSearchComponent } from '../widget/case-number-search/case-number-search.component';
import { AppConstantsService } from '@app/dashboard/services/app-constants.service';


@Component({
  selector: 'app-hearing-notice',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    BreadcrumbComponent,
    MatIconModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    CaseNumberSearchComponent
  ],
  providers: [DatePipe],
  templateUrl: './hearing-notice.component.html',
  styleUrls: ['./hearing-notice.component.scss'],
})
export class HearingNoticeComponent {
  public caseCategoryEnum = ECaseCategory;
  courtData: ILoginData | null = null;
  public caseCategoryName: WritableSignal<'Case' | 'Appeal'> = signal('Case');

  public breadcrumbs: WritableSignal<IBreadcrumb[]> = signal([
    { label: this.sessionConstant.COURT_CASE_LABEL },
    { label: `Hearing ${this.sessionConstant?.HEARING_LABEL}` },
  ]);
  pageTitle: string = `Hearing ${this.sessionConstant?.HEARING_LABEL}`;
  displayedColumns: string[] = [];

  isLoading = false;
  totalCount: number = 0;
  public caseListLoader: WritableSignal<boolean> = signal(false);
  public caseList: WritableSignal<ICaseItem[]> = signal([]);
  public searchCaseList: WritableSignal<HearingNotice[]> = signal([]);
  public task: WritableSignal<IAssignedTask | null> = signal(null);
  userType: string = "";

  selection = new SelectionModel<any>(false, []);
  closeTaskLoading: boolean = false;

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.searchCaseList().length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.searchCaseList().forEach(row => this.selection.select(row));
  }

  public caseCategories: TKeyValue[] = [
    { key: this.caseCategoryEnum.FI, value: 'First Instance' },
    { key: this.caseCategoryEnum.A, value: 'Appeal' },
  ];

  public searchForm: FormGroup = new FormGroup({
    caseNumber: new FormControl('', { nonNullable: true, validators: [Validators.required] }),

  });

  constructor(
    private assignTaskService: AssignedTaskService,
    private dialog: MatDialog,
    private service: DocumentReceptionService,
    private hearingService: HearingNoticeService,
    private datePipe: DatePipe,
    private dialogService: DialogService,
    public sessionConstant: AppConstantsService,
  ) {

    //this.searchbyCaseNoChange();
    this.assignTaskService.assignTask$
      .pipe(
        takeUntilDestroyed(),
        filter(event => event.name === ETaskScreenName.HEARINGNOTICE)
      )
      .subscribe({
        next: (event: IAssignedTaskEvent) => {
          this.selection.clear();
          this.task.set(event.task);
          this.searchForm.reset({
            caseNumber: event.task.courtCaseNumber
          });
          this.searchHandler(event.task.courtCaseNumber);


        }
      });
    effect(() => {
      // this.caseDataSource.data = this.caseData(); // Bind signal value to the data source
    });

  }
  ngOnInit(): void {
    this.selection.clear();
    this.loadCourtData(); // Call method on component loa

  }

  private searchbyCaseNoChange() {
    this.searchForm.controls['caseNumber'].valueChanges
      .pipe(
        takeUntilDestroyed(),
        filter(val => {
          if (typeof val === 'string' && val.trim().length > 3) {
            this.caseListLoader.set(true);
            return true;
          }
          this.caseListLoader.set(false);
          return false;
        }),
        debounceTime(500),
        switchMap((searchVal: string) => this.searchCases(searchVal))
      )
      .subscribe({
        next: (res: IResponse<ICaseItem[]>) => {
          this.caseList.set(res.data);
          this.caseListLoader.set(false);
        },
        error: () => {
          this.caseListLoader.set(false);
        }
      });
  }
  // Ensure only one row is selected at a time
  onCheckboxChange(row: HearingNotice): void {
    this.selection.clear();         // Clear any previous selection
    this.selection.select(row);     // Select the new row
  }


  private searchCases(val: string) {
    const body: ICaseSearchRequestBody = {
      caseNumber: val,
      dateOfFiling: 'null'
    };
    const params: ISearchRequestParams = {
      page: 1,
      start: 0,
      limit: 25,
      property: 'id',
      direction: 'ASC'
    }
    return this.service.searchCaseNumber(body, params);
  }

  public searchHandler(caseNumber?: string) {
    if (caseNumber === undefined) {
      this.task.set(null);
    }
    if (this.searchForm.valid || (caseNumber || caseNumber != null || caseNumber != '' || caseNumber != undefined)) {
      const docTypeId = this.searchForm.value.docTypeId || '';
      const reqBody: TAny = {
        appealNumber: caseNumber || this.searchForm.value.caseNumber,
      };
      // Reset the form and state


      this.getCaseData(reqBody);

    }
    else {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Please select or Enter Case Number',
          icon: 'info', // ✅ Default icon if not provided
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
    }
  }
  public getCaseData(reqBody: TAny) {
    this.searchCaseList.set([]);
    this.isLoading = true;

    this.hearingService.searchCaseDetailsHN(reqBody).subscribe({
      next: (res: IResponse<HearingNotice[]>) => {
        if (res && res.data) {
          this.searchCaseList.set(res.data);
          const containsAppeal = res.data.some(item => item.caseCategory === 'A');
          this.updateDisplayedColumns(containsAppeal);
          this.isLoading = false;
        } else {
          this.dialogService.openDialog1({
            data: {
              title: "Information",
              message: 'No Privilege to access the data (or) No Data Exists',
              icon: 'info', // ✅ Default icon if not provided
            }, disableClose: true,           // Prevents closing on outside click or ESC
            hasBackdrop: true,            // Shows backdrop to block interaction
            backdropClass: 'dialog-backdrop', // Optional: custom styling
          });
        }

      },
      error: (err) => {
        console.error('Error fetching case data:', err);

      },
    });
  }
  updateDisplayedColumns(showOldSuitNumber: boolean): void {

    if (showOldSuitNumber) {
      this.displayedColumns = ['select', 'appealNumber', 'oldSuitNumber', 'appellant', 'respondant', 'hearingDate']
    } else {
      this.displayedColumns = ['select', 'appealNumber', 'appellant', 'respondant', 'hearingDate']
    }


  }


  public caseDisplayFn(item: CaseRecord) {
    return item && item.caseNumber;
  }
  getCourtNameData(): ILoginData | null {
    try {
      const userData = localStorage.getItem('userData') as string;
      return userData ? JSON.parse(userData) : null;
    } catch (err) {
      return null
    }

  }

  loadCourtData(): void {
    this.courtData = this.getCourtNameData();
    //console.log('Loaded Court Data:', this.courtData);
    if (this.courtData?.courtId === 1 || this.courtData?.courtId === 2) {
      this.userType = 'admin';
    } else {
      this.userType = 'lawyer'
    }
  }

  formatToDateTimeString(ms: number): string | null {
    return this.datePipe.transform(ms, 'yyyy-MM-ddTHH:mm:ss');
  }
  onReset() {
    this.searchForm.reset();
    this.caseList.set([]);
    this.searchCaseList.set([]);
    this.selection.clear();
  }

  public onCaseSearchOptionSelected(item: any): void {
    const caseNo = item?.caseNumber || item?.courtCaseNumber || '';
    if (caseNo) {
      this.searchForm.patchValue({ caseNumber: caseNo });
    }
  }
  onPrint() {

    const selectedRow = this.selection.selected[0];

    // ❗ Check if a row is selected
    if (!selectedRow) {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Please select a row before printing.',
          icon: 'info',
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
      return;
    }

    const reqparams: TAny = {
      id: selectedRow.id,
      appealNumber: selectedRow.appealNumber,
      oldAppealNumber: selectedRow.oldAppealNumber,
      suitNumber: selectedRow.suitNumber,
      appellant: selectedRow.appellant,
      respondent: selectedRow.respondent, // Note: make sure this is not a typo (respondent vs respondant)
      hearingDate: this.formatToDateTimeString(selectedRow.hearingDate),
      timeCreated: this.formatToDateTimeString(selectedRow.timeCreated),
      caseCategory: selectedRow.caseCategory,
      divisionId: selectedRow.divisionId,
      caseDivisionName: selectedRow.caseDivisionName,
      uniqueIdProperty: '',
      cutId: selectedRow.cutId,
      caseCourtUnitName: selectedRow.caseCourtUnitName
    };

    this.hearingService.feePaymentPrint(reqparams).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      },
      error: (err) => {
        console.error('Error while printing:', err);
        this.dialogService.openDialog1({
          data: {
            title: "Failed",
            message: 'Failed to generate print file.',
            icon: 'error',
          }, disableClose: true,           // Prevents closing on outside click or ESC
          hasBackdrop: true,            // Shows backdrop to block interaction
          backdropClass: 'dialog-backdrop', // Optional: custom styling
        });
      },
    });
  }

  public closeTaskHandler() {


    // 2. Open confirmation dialog first
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm Action',
        message: "Are you sure you want to close this task?",
      }, disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Only proceed if user clicked confirm/yes
      if (!result) return;

      // 3. Construct payload params
      const data = this.searchCaseList()[0];

      const reqParams = {

        "taskId": this.task()?.tasksId,
        "courtCaseNumber": data.appealNumber,
        "casePhaseId": data.cphId,
        "casePhaseCasId": data.casePhaseCasId,
        "courtUnitId": data.cutId,
        "caseCategory": data.caseCategory
      }

      // 4. Fire API call
      this.hearingService.closeTask(reqParams).subscribe({
        next: (res: IResponse<TAny>) => {
          const isSuccess = res && res.success;

          // Show structured response feedback
          this.showStatusDialog(
            isSuccess ? "Success" : "Failed",
            res?.message || "An error occurred",
            isSuccess ? "success" : "info"
          );

          if (isSuccess) {
            this.searchCaseList.set([]);
            this.selection.clear(); // Clear the checkbox selection state
          }
        }
      });
    });
  }

  /**
   * Reusable helper to show alerts without duplicating configuration code
   */
  private showStatusDialog(title: string, message: string, icon: string) {
    this.dialogService.openDialog1({
      data: { title, message, icon },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop'
    });
  }
}